import { Component, Input } from '@angular/core';
import { InspectionConfigBaseAuth } from '../../../models/InspectionConfiguration';
import { CommonModule } from '@angular/common';
import { ControlContainer, FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-base-auth-configs',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  viewProviders: [
    { provide: ControlContainer, useExisting: NgForm }
  ],
  templateUrl: './base-auth-configs.component.html',
  styleUrl: './base-auth-configs.component.scss'
})
export class BaseAuthConfigsComponent {
  showPassword = false;
  showApiKey = false;
  @Input()
  authConfig: InspectionConfigBaseAuth = {};
}
